import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')



// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const RecoverPassword = () => import('@/views/pages/RecoverPassword')

// Users
//const Users = () => import('@/views/users/Users')

//Notes
const Notes = () => import('@/views/notes/Notes')
const Note = () => import('@/views/notes/Note')
const EditNote = () => import('@/views/notes/EditNote')
const CreateNote = () => import('@/views/notes/CreateNote')

//Roles
const Roles = () => import('@/views/roles/Roles')
const Role = () => import('@/views/roles/Role')
const EditRole = () => import('@/views/roles/EditRole')
const CreateRole = () => import('@/views/roles/CreateRole')



const Menus       = () => import('@/views/menu/MenuIndex')
const CreateMenu  = () => import('@/views/menu/CreateMenu')
const EditMenu    = () => import('@/views/menu/EditMenu')
const DeleteMenu  = () => import('@/views/menu/DeleteMenu')


const Media = () => import('@/views/media/Media')

// Orders

const Orders = () => import('@/views/pages/Orders');
const CreateOrder = () => import('@/views/pages/CreateOrder');
const UpdateOrder = () => import('@/views/pages/UpdateOrder');

// Usuarios

const Users = () => import('@/views/pages/Users')
const CreateUser = () => import('@/views/pages/CreateUser')
const UpdateUser = () => import('@/views/pages/UpdateUser')

// Ordenes automaticas

const ScheduledOrders = () => import('@/views/pages/ScheduledOrders');
const UpdateScheduledOrder = () => import('@/views/pages/UpdateScheduledOrder');

Vue.use(Router)

let router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

const apiTokenName = process.env.VUE_APP_API_TOKEN_NAME

router.beforeEach((to, from, next) => {
  // Solo para los que tengan como meta requiresLogin
  if(to.matched.some(record => record.meta.requiresLogin)) {
    let cookie = Vue.$cookies.get(apiTokenName);
    if(cookie){
      next(); // Acá habría que chequear de alguna manera que el token siga siendo válido
    } else {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath}
      })
    }
  }else{
    next()
  }

  if(to.matched.some(record => record.meta.requiresRole)){
    // TODO: Logica para chequear los roles
  }
})

export default router

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/ordenes',
      name: 'Inicio',
      component: TheContainer, // Meter la vista acá adentro para obtener la nav y la sidebar
      children: [
        {
          path: '/ordenes',
          meta: {label: 'Ordenes',},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Orders,
              meta:{
                requiresLogin: true
              }
            },
            {
              path: '/ordenes/crear/',
              name: 'Crear Orden',
              component: CreateOrder,
              meta:{
                requiresLogin: true,
                label: 'Crear Orden'
              }
            },
            {
              path: '/ordenes/modificar/:orderId',
              name: 'Modificar solicitud',
              component: UpdateOrder,
              props: true,
              meta: {
                requiresLogin: true,
                label: 'Modificar Solicitud'
              }
            },
          ]
        },
        {
          path: '/usuarios',
          meta: {label: 'Usuarios'},
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '',
              //name: 'Usuarios',
              component: Users,
              meta: {
                requiresLogin: true,
                //label: 'Principal'
              }
            },
            {
              path: '/usuarios/crear',
              name: 'Crear Usuario',
              component: CreateUser,
              meta:{
                requiresAdmin: true,
                requiresLogin: true,
                label: 'Crear usuario'
              }
            },
            {
              path: '/usuarios/modificar/:userId',
              name: 'Modificar Usuario',
              component: UpdateUser,
              props: true,
              meta:{
                requiresLogin: true,
                label: 'Crear Usuario'
              }
            },
          ]
        },
        {
          path: '/ordenes_automaticas',
          meta: {label: 'Ordenes automaticas',},
          component: {
            render(c) {return c('router-view')}
          },
          children: [
            {
              path: '',
              component: ScheduledOrders,
              meta: {
                requiresLogin: true
              }
            },
            {
              path: '/ordenes_automaticas/modificar/:orderId',
              name: 'Modificar solicitud',
              component: UpdateScheduledOrder,
              props: true,
              meta: {
                requiresLogin: true,
                label: 'Modificar Solicitud'
              }
            },
          ]
         
        },
        {
          path: 'media',
          name: 'Media',
          component: Media,
          meta:{
            requiresAdmin: true
          }
        },
        /*{
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },*/
        {
          path: 'colors',
          name: 'Colors',
          component: Colors,
          meta:{
            requiresUser: true
          }
        },
        {
          path: 'typography',
          name: 'Typography',
          component: Typography,
          meta:{
            requiresUser: true
          }
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts,
          meta:{
            requiresUser: true
          }
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets,
          meta:{
            requiresUser: true
          }
        },
        {
          path: 'menu',
          meta: { label: 'Menu'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Menus,
              meta:{
                requiresAdmin: true
              }
            },
            {
              path: 'create',
              meta: { label: 'Create Menu' },
              name: 'CreateMenu',
              component: CreateMenu,
              meta:{
                requiresAdmin: true
              }
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Menu' },
              name: 'EditMenu',
              component: EditMenu,
              meta:{
                requiresAdmin: true
              }
            },
            {
              path: ':id/delete',
              meta: { label: 'Delete Menu' },
              name: 'DeleteMenu',
              component: DeleteMenu,
              meta:{
                requiresAdmin: true
              }
            },
          ]
        },
      ],
      meta: {
        requiresLogin: true,
        
      },

    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter: (to, from, next) => {
            if(Vue.$cookies.get(apiTokenName)){
              next({
                path: '/ordenes',
                params: {nextUrl: to.fullPath}
              })
            } else {
              next();
            }
          },
          meta: {
            allowGuest: true,

          }
        },
        {
          path: 'recuperar-contrasena',
          name: "Recuperar contraseña",
          component: RecoverPassword,
          meta: {
            allowGuest: true
          }
        }
      ]
    },
   
    {
      path: '*',
      name: '404',
      component: Page404
    },
    
  ]
}
